import React from 'react'
import AppBar from '../../components/NavBar/NavBar'
import "./index.css"; // Import the CSS file
import { Outlet } from 'react-router-dom';

function UserLayout() {
  return (
    <>
        <AppBar />
        <main className='main-container' >
        <Outlet />
        </main>
    </>

  )
}

export default UserLayout